"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _ToggleButtonsGroup = _interopRequireDefault(require("../../../ToggleButtonsGroup"));
var _communication = require("../../../../icons-react/communication");
var _constants = require("../../../../constants");
var _excluded = ["types", "values", "onChange"];
var StyledButton = _ToggleButtonsGroup["default"].StyledButton;
var availableIcons = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _constants.CLIENT_LOG_TYPES.CALL, /*#__PURE__*/_react["default"].createElement(_communication.Call, {
  width: 15,
  height: 15
})), _constants.CLIENT_LOG_TYPES.EMAIL, /*#__PURE__*/_react["default"].createElement(_communication.Mail, {
  width: 15,
  height: 13
})), _constants.CLIENT_LOG_TYPES.NOTE, /*#__PURE__*/_react["default"].createElement(_communication.Note, {
  width: 14,
  height: 14
})), _constants.CLIENT_LOG_TYPES.MESSAGE, /*#__PURE__*/_react["default"].createElement(_communication.Message, {
  width: 16,
  height: 15
})), _constants.CLIENT_LOG_TYPES.SMS, /*#__PURE__*/_react["default"].createElement(_communication.Message, {
  width: 16,
  height: 15
})), _constants.CLIENT_LOG_TYPES.MESSAGE_GROUP, /*#__PURE__*/_react["default"].createElement(_communication.Group, {
  width: 16,
  height: 13
})), _constants.CLIENT_LOG_TYPES.MANAGER_EMAIL, /*#__PURE__*/_react["default"].createElement(_communication.Bot, {
  width: 16,
  height: 15
}));
var CommunicationFilters = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var types = _ref.types,
    values = _ref.values,
    onChange = _ref.onChange,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledCommunicationFilters, props, /*#__PURE__*/_react["default"].createElement(StyledTogglers, {
    multiple: true,
    values: values,
    onChange: onChange
  }, types.map(function (type) {
    return /*#__PURE__*/_react["default"].createElement(StyledToggleButton, {
      key: type,
      value: type
    }, availableIcons[type]);
  })));
});
CommunicationFilters.displayName = 'CommunicationFilters';
CommunicationFilters.propTypes = {
  className: _propTypes["default"].string,
  values: _propTypes["default"].arrayOf(_propTypes["default"].oneOf(Object.values(_constants.CLIENT_LOG_TYPES)).isRequired).isRequired,
  types: _propTypes["default"].arrayOf(_propTypes["default"].oneOf(Object.values(_constants.CLIENT_LOG_TYPES)).isRequired).isRequired,
  onChange: _propTypes["default"].func
};
CommunicationFilters.defaultProps = {
  className: '',
  onChange: Function.prototype
};
var StyledCommunicationFilters = _styledComponents["default"].div.withConfig({
  displayName: "CommunicationFilters__StyledCommunicationFilters",
  componentId: "sc-sewne4-0"
})([""]);
var StyledTogglers = (0, _styledComponents["default"])(_ToggleButtonsGroup["default"]).withConfig({
  displayName: "CommunicationFilters__StyledTogglers",
  componentId: "sc-sewne4-1"
})(["", "{line-height:40px;&:first-child{padding-left:18px;}&:last-child{padding-right:15px;}}"], StyledButton);
var StyledToggleButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "CommunicationFilters__StyledToggleButton",
  componentId: "sc-sewne4-2"
})(["> svg{stroke:white;rect,path{stroke:#007aff;}}", ""], function (props) {
  return props.checked && "\n    background: #007aff;\n    > svg rect { stroke: white; }\n    > svg path { stroke: white; }\n  ";
});
var _default = exports["default"] = CommunicationFilters;